module.exports = __webpack_public_path__ + "static/img/cross-round.4dd573e4.svg";